// Currency formatter for Indian Rupees
export const currencyFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0
});

// Number formatter for Indian locale
export const numberFormatter = new Intl.NumberFormat("en-IN", {
  maximumFractionDigits: 0
});

// Time formatter
export const formatTime = (date) => {
  if (!date) return "";
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

// Date and time formatter (e.g., "Dec 5, 4:59 PM")
export const formatDateTime = (date) => {
  if (!date) return "";
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

